import React, { useState } from "react";
import "react-alice-carousel/lib/alice-carousel.css";
import Slider from "react-slick";
import "./styles.css";

export default function ProductItemComponent() {
  const [active, setActive] = useState("คำอธิบาย");
  const renderProductItemBackground = (
    <div className="product-item-background"></div>
  );

  const renderVarationItem = (
    <>
      <div className="product-item-variation-title">Select Variations:</div>
      <div className="variation-wrapper">
        <button className="variation-item">
          <img
            alt="cat's taste"
            className="variation-img"
            src="/assets/icons/tasty-products.png"
          />
          <div className="variation-title">อาหารแมวเปียกในเกรวี่</div>
        </button>
        <button className="variation-item">
          <img
            alt="cat's taste"
            className="variation-img"
            src="/assets/icons/tasty-products.png"
          />
          <div className="variation-title">อาหารแมวเปียกในเกรวี่</div>
        </button>
      </div>
    </>
  );

  const renderSizeOption = (
    <>
      <div className="product-item-size-title">SELECT Sizes: </div>
      <div className="size-wrapper">
        <button className="size-item">กระป๋อง ขนาด 85g.</button>
        <button className="size-item">กระป๋อง ขนาด 170g.</button>
        <button className="size-item">ซอง ขนาด 70g.</button>
      </div>
    </>
  );

  const renderIngredients = (
    <>
      <div className="product-item-ingredient-title">Key ingredientS</div>
      <div className="ingredient-wrapper">
        <div className="ingredient-item">
          <img
            alt="cat's taste"
            className="ingredient-img"
            src="/assets/icons/tuna-ingredient.svg"
          />
          <div className="ingredient-title">Just tuna!</div>
        </div>
        <div className="ingredient-item">
          <img
            alt="cat's taste"
            className="ingredient-img"
            src="/assets/icons/chicken-ingredient.svg"
          />
          <div className="ingredient-title">Chicken topping</div>
        </div>
        <div className="ingredient-item">
          <img
            alt="cat's taste"
            className="ingredient-img"
            src="/assets/icons/salmon-ingredient.svg"
          />
          <div className="ingredient-title">Salmon topping</div>
        </div>
        <div className="ingredient-item">
          <img
            alt="cat's taste"
            className="ingredient-img"
            src="/assets/icons/rice-fish-ingredient.svg"
          />
          <div className="ingredient-title">Rice fish topping</div>
        </div>
      </div>
    </>
  );

  const renderDescription = (
    <div>
      <div className="description-header">
        <div
          className={
            active === "คำอธิบาย"
              ? "description-btn-background1"
              : "description-btn-background"
          }
          onClick={() => setActive("คำอธิบาย")}
        >
          คำอธิบาย
        </div>
        <div
          className={
            active === "วิธีการให้อาหารแมวในแต่ละวัน"
              ? "description-btn-background2"
              : "description-btn-background"
          }
          onClick={() => setActive("วิธีการให้อาหารแมวในแต่ละวัน")}
        >
          วิธีการให้อาหารแมวในแต่ละวัน
        </div>
        <div
          className={
            active === "คำแนะนำในการเก็บรักษา"
              ? "description-btn-background3"
              : "description-btn-background"
          }
          onClick={() => setActive("คำแนะนำในการเก็บรักษา")}
        >
          คำแนะนำในการเก็บรักษา
        </div>
      </div>
      {active === "คำอธิบาย" && (
        <div className="description-wrapper">
          <div className="description-item">
            <img
              alt="cat's taste"
              className="description-img"
              src="/assets/icons/our-value-sodium-red.png"
            />
            <div className="description-title">No sodium added</div>
          </div>
          <div className="description-item">
            <img
              alt="cat's taste"
              className="description-img"
              src="/assets/icons/our-value-grain-red.png"
            />
            <div className="description-title">Grain-Free</div>
          </div>
          <div className="description-item">
            <img
              alt="cat's taste"
              className="description-img"
              src="/assets/icons/our-value-preservative-red.png"
            />
            <div className="description-title">No Preservatives</div>
          </div>
          <div className="description-item">
            <img
              alt="cat's taste"
              className="description-img"
              src="/assets/icons/our-value-quality-red.png"
            />
            <div className="description-title">Japanese quality</div>
          </div>
          <div className="description-item">
            <img
              alt="cat's taste"
              className="description-img"
              src="/assets/icons/our-value-human-red.png"
            />
            <div className="description-title">HUMAN-GRADE FOOD</div>
          </div>
        </div>
      )}
      {active === "วิธีการให้อาหารแมวในแต่ละวัน" && (
        <div className="methods-wrapper">
          <div className="methods-item">
            <div className="cat-weight-title">นน. แมว 1-3 กก.</div>
            <img
              alt="cat's taste"
              className="cat-weight1"
              src="/assets/icons/cat-weight.svg"
            />
            <div className="cat-weight-pack-wrapper1">
              <img
                alt="cat's taste"
                className="cat-weight-pack1"
                src="/assets/icons/cat-weight-pack1.svg"
              />
              <div className="cat-weight-subtitle">2/5 - 4/5 ถุง/วัน</div>
            </div>
          </div>
          <div className="methods-item">
            <div className="cat-weight-title">นน. แมว 3-5 กก.</div>
            <img
              alt="cat's taste"
              className="cat-weight2"
              src="/assets/icons/cat-weight.svg"
            />
            <div className="cat-weight-pack-wrapper2">
              <img
                alt="cat's taste"
                className="cat-weight-pack2"
                src="/assets/icons/cat-weight-pack2.svg"
              />
              <div className="cat-weight-subtitle">4/5 - 1 ถุง/วัน</div>
            </div>
          </div>
          <div className="methods-item">
            <div className="cat-weight-title">นน. แมว 5+ กก.</div>
            <img
              alt="cat's taste"
              className="cat-weight3"
              src="/assets/icons/cat-weight.svg"
            />
            <div className="cat-weight-pack-wrapper3">
              <img
                alt="cat's taste"
                className="cat-weight-pack3"
                src="/assets/icons/cat-weight-pack3.svg"
              />
              <div className="cat-weight-subtitle">1 ถุง+/วัน</div>
            </div>
          </div>
        </div>
      )}
      {active === "คำแนะนำในการเก็บรักษา" && (
        <div className="instruction">
          <div className="instruction-title">วิธีใช้และขนาดการใช้</div>
          <div className="instruction-subtitle">
            บริโภคได้ทันทีหลังจากเปิดถุง
          </div>
          <div className="instruction-subtitle">
            ควรให้อาหารอื่นเพิ่มเติมเพื่อให้แมวได้รับสารอาหารเพียงพอต่อความต้องการของร่างกาย
          </div>
          <div className="instruction-subtitle">
            หลังจากเปิดถุงควรเก็บไว้ในตู้เย็น เก็บได้ไม่เกิน 2 วัน
          </div>
        </div>
      )}
    </div>
  );

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const renderSlider = (
    <>
      <div className="carousel-header-background"></div>
      <div className="project-item-container">
        <link
          rel="stylesheet"
          type="text/css"
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
        <div className="product-item-carousel-header">
          <div className="carousel-tasty-wrapper">
            <img alt="cat's taste" src="/assets/icons/cat-mouth.svg" />
            <div className="carousel-title-tasty">Tasty</div>
          </div>
          <button className="shop-now-btn">SHOP NOW</button>
        </div>
        <Slider {...settings}>
          <div className="carousel-item">
            <img alt="cat's taste" src="/assets/icons/tasty-products.png" />
            <div className="carousel-item-title">Wet Cat Food tuna flavour</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <button className="carousel-btn">SHOPEE</button>
              <button className="carousel-btn">LAZADA</button>
            </div>
          </div>
          <div className="carousel-item">
            <img alt="cat's taste" src="/assets/icons/tasty-products.png" />
            <div className="carousel-item-title">Wet Cat Food tuna flavour</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <button className="carousel-btn">SHOPEE</button>
              <button className="carousel-btn">LAZADA</button>
            </div>
          </div>
          <div className="carousel-item">
            <img alt="cat's taste" src="/assets/icons/tasty-products.png" />
            <div className="carousel-item-title">Wet Cat Food tuna flavour</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <button className="carousel-btn">SHOPEE</button>
              <button className="carousel-btn">LAZADA</button>
            </div>
          </div>
          <div className="carousel-item">
            <img alt="cat's taste" src="/assets/icons/tasty-products.png" />
            <div className="carousel-item-title">Wet Cat Food tuna flavour</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <button className="carousel-btn">SHOPEE</button>
              <button className="carousel-btn">LAZADA</button>
            </div>
          </div>
          <div className="carousel-item">
            <img alt="cat's taste" src="/assets/icons/tasty-products.png" />
            <div className="carousel-item-title">Wet Cat Food tuna flavour</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <button className="carousel-btn">SHOPEE</button>
              <button className="carousel-btn">LAZADA</button>
            </div>
          </div>
          <div className="carousel-item">
            <img alt="cat's taste" src="/assets/icons/tasty-products.png" />
            <div className="carousel-item-title">Wet Cat Food tuna flavour</div>
            <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
            <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเกรวี่</div>
            <div className="carousel-btn-wrapper">
              <button className="carousel-btn">SHOPEE</button>
              <button className="carousel-btn">LAZADA</button>
            </div>
          </div>
        </Slider>
      </div>
    </>
  );

  return (
    <div>
      {renderProductItemBackground}
      <div className="product-item-card">
        <div className="product-item-card-grid">
          <img
            alt="cat's taste"
            className="tasty-products-img"
            src="/assets/icons/tasty-products.png"
          />
          <div className="product-item-detail">
            <div className="product-item-card-title-grid">
              <img
                alt="cat's taste"
                className="cat-mouth-img"
                src="/assets/icons/cat-mouth.svg"
              />
              <div>
                <div className="product-item-card-title">
                  Wet Cat Food tuna flavour
                </div>
                <div className="product-item-card-subtitle">
                  อาหารเปียกแมวสูตรปลาทูน่า
                </div>
              </div>
            </div>
            {renderVarationItem}
            {renderSizeOption}
            {renderIngredients}
            <div className="product-item-btn-wrapper">
              <button className="product-item-btn-shopee">
                <img
                  alt="cat's taste"
                  className="product-item-shopee-icon"
                  src="/assets/icons/shopee-icon.svg"
                />
                <div className="product-btn-title">SHOPEE</div>
              </button>
              <button className="product-item-btn-lazada">
                <img
                  alt="cat's taste"
                  className="product-item-lazada-icon"
                  src="/assets/icons/lazada-icon.svg"
                />
                <div className="product-btn-title">Lazada</div>
              </button>
            </div>
          </div>
        </div>
        {renderDescription}
      </div>
      {renderSlider}
    </div>
  );
}
